module.exports = __webpack_public_path__ + "img/swiper3.5e71f3aa.jpg";